<template>
  <div>
 <div  v-for="(item,index) in dataList" :key="index">
    <van-cell :title="item.name" :label="item.content" :value="item.phoneNo" />
 </div>
  </div>
</template>
<script>
import URL from "@/api/api";

export default {
  data() {
    return {
      dataList: {
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let userId = localStorage.getItem("userid");
      this.$fetchGet(URL.getQAList.url, {userId: userId}).then(res => {
        this.dataList = res.data.data
      })
    },
  }
};
</script>

<style lang="less">

</style>
